import React, { useState } from "react";
import "./WhatsAppBot.css"; // Import the CSS file

const WhatsAppBot = () => {
  const [isPopupVisible, setPopupVisible] = useState(false);

  const togglePopup = () => {
    setPopupVisible(!isPopupVisible);
  };

  return (
    <div className="whatsappbot">
          <div className="iconwa" id="whatsapp-icon" onClick={togglePopup}>
              <img src={require("../img/whatsapp/whatsappicon.svg").default} alt="WhatsApp Icon" />
      </div>

      {isPopupVisible && (
        <div className="whatsapp-popup" id="whatsapp-popup">
          <div className="waheader">
            <div className="headericon">
              <img src={require("../img/whatsapp/whatsappicon.svg").default} alt="icon" />
            </div>
            <div>
              <div className="firstheading">SMC Insurance</div>
              <div>Insure wise. Be wise.</div>
            </div>
            <button
              className="close-btn"
              id="close-btn"
              onClick={() => setPopupVisible(false)}
            >
              &times;
            </button>
          </div>
          <div className="body">
            <div className="content">
              <div className="username">SMC Insurance</div>
              <p>
                Welcome to SMC.
                <br /> How may I assist you?
              </p>
            </div>
          </div>
          <div className="btn-container">
            <a
              className="start-chat-btn"
              href="https://api.whatsapp.com/send?phone=919911588988&text=Hi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={require("../img/whatsapp/whatsappicon.svg").default}
                alt="WhatsApp Icon"
                style={{ width: "20px", marginRight: "8px" }}
              />
              Start Chat
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppBot;
